import { Button, Dialog } from "antd-mobile";
import style from "css/hotdesking.module.css";
import React from "react";
import { useTranslation } from "react-i18next";

function CheckOut({ onSubmit }) {
  const { t } = useTranslation();
  const onClose = () => {
    Dialog.clear();
  };
  const onClick = () => {
    onSubmit();
    onClose();
  };
  return (
    <section className={style.confirm_content}>
      <article className={style.content_article}>
        <p>{t("HOTDESKING.MODAL.CHECK_OUT.MESSAGE.CHECK_OUT")}</p>
      </article>
      <section className={style.content_footer}>
        <Button className={style.cancel_button} onClick={onClose}>
          {t("HOTDESKING.BUTTON.CANCEL")}
        </Button>
        <Button className={style.submit_button} onClick={onClick}>
          {t("HOTDESKING.BUTTON.CONFIRM")}
        </Button>
      </section>
    </section>
  );
}

export default CheckOut;
